<template lang="pug">
.card-container
  .card-heading
    .title-container
      .title {{ title }}
      .sub-title {{ subTitle  }}
    .learn-more(v-if="hasLearnMore" @click="$emit('more')")
      | 更多内容
      i.el-icon-right
  .card-content(v-loading="loading")
    slot
      el-empty(description="")
</template>

<script>
export default {
  name: "CardContainer",
  props: {
    title: String,
    subTitle: String,
    loading: Boolean,
  },
  computed: {
    /**
     * 是否有more事件
     * @returns {boolean}
     */
    hasLearnMore() {
      return Object.prototype.hasOwnProperty.call(this.$listeners, 'more');
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container{
  padding: 8px 16px;
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .card-heading{
    height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .title-container{
      flex: 1;
      display: flex;
      align-items: end;
      color: $title_color;
      font-size: 20px;
      font-weight: 700;
      .sub-title{
        font-size: 12px;
        line-height: 18px;
        color: $title_color;
        text-transform: uppercase;
        margin-left: 20px;
      }
    }
    
    .learn-more{
      cursor: pointer;
      font-size: 12px;
      color: #202948;
      i{
        margin-left: 8px;
      }
    }
  }
  .card-content{
    flex: 1;
    padding: 16px 0 8px;
  }
}
</style>
